import { ManualState } from './types'

export const state: ManualState = {
    percent: 0,
    loading: false
}